export const reviews = [
  {
    name: 'Игорь Морозов',
    company: 'Кофейня «Roast»',
    rating: 5,
    text: 'За три месяца сообщество выросло с 4 до 21 тысячи подписчиков. Впервые увидели, как заявки в сообщения приходят стабильно, а не волнами.',
  },
  {
    name: 'Алина Петрова',
    company: 'Блогер, 78 тыс. подписчиков',
    rating: 5,
    text: 'Аккуратно упаковали паблик и настроили таргет. Отчёты понятные, без лишней воды — все цифры на виду.',
  },
  {
    name: 'Сергей Данилов',
    company: 'Автосервис «Гараж 55»',
    rating: 5,
    text: 'Приятно, что не забрали доступы и всё показывали на созвонах. Записей на ремонт стало заметно больше уже в первый месяц.',
  },
  {
    name: 'Наталья Ершова',
    company: 'Стоматология «Dental+»',
    rating: 5,
    text: 'Понравился строгий подход к аналитике. Выстроили контент-план, и сообщество перестало быть «мёртвым»: комментарии и заявки каждый день.',
  },
  {
    name: 'Павел Крылов',
    company: 'Фитнес-клуб «Atlas»',
    rating: 5,
    text: 'Работали по договору, весь бюджет прозрачный. Итог — заполненные группы и очередь на пробные тренировки к концу квартала.',
  },
  {
    name: 'Ольга Смирнова',
    company: 'Школа английского «Lingua»',
    rating: 5,
    text: 'Ценно, что команда отвечает быстро и предлагает решения, а не просто «крутит рекламу». Заявки на обучение выросли в 2,5 раза.',
  },
  {
    name: 'Дмитрий Савельев',
    company: 'Интернет-магазин «Volt»',
    rating: 5,
    text: 'Подписчики растут каждый день, а главное — приходят целевые клиенты. Конверсия в заказы выросла почти вдвое.',
  },
  {
    name: 'Елена Кузнецова',
    company: 'Салон красоты «Lumière»',
    rating: 5,
    text: 'Очень приятная команда, всё объясняют простыми словами. Записи на услуги расписаны на неделю вперёд.',
  },
  {
    name: 'Алексей Тихонов',
    company: 'Студия ремонта «Домовёнок»',
    rating: 5,
    text: 'Впервые реклама окупилась. Заявки на ремонт идут стабильно, менеджер на связи каждый день.',
  },
  {
    name: 'Мария Соловьёва',
    company: 'Кондитерская «Сладкий дом»',
    rating: 5,
    text: 'Красиво упаковали сообщество, подписчики стали активнее комментировать. Заказы на торты выросли в полтора раза.',
  },
  {
    name: 'Виктор Лапин',
    company: 'Сервис доставки «Быстро+»',
    rating: 5,
    text: 'Чёткая аналитика и понятные цифры. Видно, сколько стоит клиент, и это окупается.',
  },
  {
    name: 'Анна Жукова',
    company: 'Детский центр «Радуга»',
    rating: 5,
    text: 'Привели родителей из нужного района. Группы на занятия заполнились за месяц.',
  },
  {
    name: 'Роман Белов',
    company: 'Барбершоп «Бритва»',
    rating: 5,
    text: 'Локальная реклама сработала отлично. Клиентов стало заметно больше, особенно в выходные.',
  },
  {
    name: 'Ксения Орлова',
    company: 'Онлайн-школа дизайна «Forma»',
    rating: 5,
    text: 'Настроили воронку от подписки до записи на курс. Поток заявок вырос, стоимость лида снизилась.',
  },
  {
    name: 'Тимур Гареев',
    company: 'Автошкола «Магистраль»',
    rating: 5,
    text: 'Стабильные заявки на обучение. Менеджер всегда на связи и быстро вносит правки.',
  },
  {
    name: 'Дарья Мельникова',
    company: 'Цветочная «Букет-онлайн»',
    rating: 5,
    text: 'Перед праздниками заказы просто взлетели. Таргет подобрали точно под нашу аудиторию.',
  },
  {
    name: 'Олег Степанов',
    company: 'Юридическая фирма «Право+»',
    rating: 5,
    text: 'Серьёзный подход к договору и отчётности. Лиды качественные, клиенты приходят целевые.',
  },
  {
    name: 'Полина Виноградова',
    company: 'Фотостудия «Кадр»',
    rating: 5,
    text: 'Подписчики растут, записи на съёмки идут. Всё прозрачно и по делу.',
  },
  {
    name: 'Андрей Корнеев',
    company: 'Магазин спортпита «ProSport»',
    rating: 5,
    text: 'Реклама окупается, заказы стабильные. Команда реально разбирается в теме.',
  },
  {
    name: 'Светлана Ильина',
    company: 'Клиника «Здоровье»',
    rating: 5,
    text: 'Привели пациентов на нужные услуги. Отчёты подробные и понятные.',
  },
  {
    name: 'Максим Чернов',
    company: 'Мебельная фабрика «Дуб»',
    rating: 5,
    text: 'Крупный проект вели отлично. Охваты и заявки растут, всё по договору.',
  },
  {
    name: 'Татьяна Филиппова',
    company: 'Турагентство «Вояж»',
    rating: 5,
    text: 'Сообщество ожило, люди стали писать в личку. Заявки на туры пошли.',
  },
  {
    name: 'Григорий Панов',
    company: 'Грузоперевозки «Транзит»',
    rating: 5,
    text: 'Простой и понятный процесс. Заявки от компаний приходят регулярно.',
  },
  {
    name: 'Лидия Маслова',
    company: 'Студия йоги «Спокойствие»',
    rating: 5,
    text: 'Привели тёплую аудиторию, абонементы покупают. Очень довольна работой.',
  },
  {
    name: 'Артём Зайцев',
    company: 'Автосервис «Мотор»',
    rating: 5,
    text: 'Записей на ремонт стало больше. Менеджер держит в курсе всех изменений.',
  },
  {
    name: 'Вера Новикова',
    company: 'Зоомагазин «Хвостик»',
    rating: 5,
    text: 'Таргет на владельцев животных сработал. Продажи выросли, отзывы от клиентов отличные.',
  },
  {
    name: 'Николай Ефимов',
    company: 'Ремонт квартир «Мастер»',
    rating: 5,
    text: 'Стабильный поток заявок на ремонт. Работают ответственно и без «пропавших» менеджеров.',
  },
  {
    name: 'Юлия Богданова',
    company: 'Магазин одежды «Style»',
    rating: 5,
    text: 'Контент стал интересным, подписчики вовлечены. Продажи через сообщество выросли.',
  },
  {
    name: 'Иван Гордеев',
    company: 'Кофейня «Зерно»',
    rating: 5,
    text: 'Локальная реклама привела много новых гостей. Очень доволен результатом.',
  },
  {
    name: 'Анастасия Крылова',
    company: 'Салон «Роскошь»',
    rating: 5,
    text: 'Красиво упаковали паблик, заявки идут. Специалисты вежливые и внимательные.',
  },
  {
    name: 'Денис Фомин',
    company: 'IT-компания «Код»',
    rating: 5,
    text: 'Привели целевые лиды из нужной сферы. Аналитика на высоком уровне.',
  },
  {
    name: 'Екатерина Родина',
    company: 'Бутик «Мода»',
    rating: 5,
    text: 'Реклама окупается, клиенты приходят тёплые. Работать комфортно и прозрачно.',
  },
  {
    name: 'Станислав Литвинов',
    company: 'Пекарня «Колос»',
    rating: 5,
    text: 'Подписчики растут, отзывы и заказы. Команда всегда на связи.',
  },
  {
    name: 'Олеся Титова',
    company: 'Центр «Развитие»',
    rating: 5,
    text: 'Привели родителей на занятия. Всё чётко, по договору и с отчётами.',
  },
  {
    name: 'Владислав Козлов',
    company: 'Магазин «Техника»',
    rating: 5,
    text: 'Заявки на технику идут стабильно. Стоимость лида приятно радует.',
  },
  {
    name: 'Марина Дроздова',
    company: 'Стоматология «Улыбка»',
    rating: 5,
    text: 'Пациенты записываются, сообщество живое. Отличная работа с аналитикой.',
  },
  {
    name: 'Константин Шилов',
    company: 'Ресторан «Веранда»',
    rating: 5,
    text: 'Привели гостей на бизнес-ланчи и банкеты. Бронирований стало заметно больше.',
  },
  {
    name: 'Людмила Аксёнова',
    company: 'Салон «Стиль»',
    rating: 5,
    text: 'Подписчики и записи растут. Менеджер вежливый, всегда на связи.',
  },
  {
    name: 'Арсений Дубровский',
    company: 'Студия интерьеров «Атмосфера»',
    rating: 5,
    text: 'Заявки на дизайн-проекты пошли уже со второй недели. Понравился системный подход и прозрачная аналитика.',
  },
  {
    name: 'Злата Романова',
    company: 'Магазин детских товаров «Карапуз»',
    rating: 5,
    text: 'Таргет на молодых мам сработал идеально. Продажи колясок и игрушек выросли в два раза за квартал.',
  },
  {
    name: 'Тимофей Волков',
    company: 'Барбершоп «Остриё»',
    rating: 5,
    text: 'Записей стало столько, что пришлось нанимать второго барбера. Очень доволен, рекомендую.',
  },
  {
    name: 'Мирослава Ковалёва',
    company: 'Онлайн-школа английского «Speak»',
    rating: 5,
    text: 'Настроили воронку от подписки до пробного урока. Стоимость лида снизилась почти втрое.',
  },
  {
    name: 'Георгий Мельников',
    company: 'Сервис такси «Драйв»',
    rating: 5,
    text: 'Привели водителей и клиентов одновременно. Реклама окупается с первых недель, всё по договору.',
  },
  {
    name: 'Валерия Никитина',
    company: 'Кондитерская «Вишня»',
    rating: 5,
    text: 'Заказы на торты расписаны на месяц вперёд. Команда реально вложилась в наш бренд.',
  },
  {
    name: 'Ростислав Громов',
    company: 'Строительная компания «Фундамент»',
    rating: 5,
    text: 'Крупные заявки на строительство домов идут стабильно. Отчётность подробная, без воды.',
  },
  {
    name: 'Эмилия Черкасова',
    company: 'Салон красоты «Жемчужина»',
    rating: 5,
    text: 'Сообщество ожило, девушки стали активнее записываться. Отдельное спасибо за красивые креативы.',
  },
  {
    name: 'Даниил Емельянов',
    company: 'Интернет-магазин обуви «Step»',
    rating: 5,
    text: 'Конверсия в покупки выросла в полтора раза. Аналитика на высшем уровне, всё видно в цифрах.',
  },
  {
    name: 'Лиана Гусейнова',
    company: 'Центр логопедии «Говорун»',
    rating: 5,
    text: 'Привели родителей из нужных районов. Запись на занятия заполнена, работаем без пауз.',
  },
  {
    name: 'Фёдор Климов',
    company: 'Автошкола «Штурвал»',
    rating: 5,
    text: 'Поток учеников вырос, группы набираются быстрее. Менеджер всегда на связи и отвечает моментально.',
  },
  {
    name: 'Агата Леонова',
    company: 'Магазин цветов «Пион»',
    rating: 5,
    text: 'Перед 8 марта заказы побили все рекорды. Таргет попал точно в нашу аудиторию.',
  },
  {
    name: 'Степан Гончаров',
    company: 'Ресторан «Очаг»',
    rating: 5,
    text: 'Бронирования на банкеты и ужины выросли. Красиво упаковали страницу и настроили рекламу.',
  },
  {
    name: 'Аделина Соколова',
    company: 'Онлайн-курсы маркетинга «Рост»',
    rating: 5,
    text: 'Привели целевых учеников, стоимость лида приятно радует. Работаем уже третий месяц, всё стабильно.',
  },
  {
    name: 'Марат Ибрагимов',
    company: 'Грузоперевозки «Логист»',
    rating: 5,
    text: 'Заявки от компаний приходят регулярно. Чёткий процесс и понятные отчёты каждую неделю.',
  },
  {
    name: 'Амелия Федотова',
    company: 'Студия йоги «Гармония»',
    rating: 5,
    text: 'Абонементы раскупаются, пришлось открывать дополнительные группы. Очень довольна результатом.',
  },
  {
    name: 'Игнат Савельев',
    company: 'Автосервис «Вихрь»',
    rating: 5,
    text: 'Записи на ремонт выросли в разы. Команда держит в курсе всех изменений и правок.',
  },
  {
    name: 'Милана Белова',
    company: 'Зоогостиница «Лапки»',
    rating: 5,
    text: 'Таргет на владельцев собак сработал. Мест на передержку не хватает в праздники, это лучший показатель.',
  },
  {
    name: 'Ефим Тихонов',
    company: 'Магазин электроники «Вольт»',
    rating: 5,
    text: 'Заявки на технику идут каждый день. Стоимость лида ниже, чем у конкурентов, рекомендую.',
  },
  {
    name: 'Ариана Павлова',
    company: 'Бутик одежды «Шарм»',
    rating: 5,
    text: 'Продажи через сообщество выросли, подписчики вовлечены. Красивые креативы и точный таргет.',
  },
  {
    name: 'Богдан Кузнецов',
    company: 'Пекарня «Хлеб да соль»',
    rating: 5,
    text: 'Локальная реклама привела много новых покупателей. Заказы на выпечку выросли, всем доволен.',
  },
  {
    name: 'Стефания Крылова',
    company: 'Детский центр «Совёнок»',
    rating: 5,
    text: 'Привели родителей на развивающие занятия. Группы заполнены, работаем без простоев.',
  },
  {
    name: 'Ярослав Никитин',
    company: 'IT-аутсорсинг «Кодекс»',
    rating: 5,
    text: 'Привели целевых клиентов из нужной ниши. Аналитика и позиционирование на высоком уровне.',
  },
  {
    name: 'Доминика Орлова',
    company: 'Стоматология «Жемчуг»',
    rating: 5,
    text: 'Пациенты записываются стабильно, сообщество живое. Отличная работа с контентом и рекламой.',
  },
  {
    name: 'Лука Анисимов',
    company: 'Фитнес-студия «Ритм»',
    rating: 5,
    text: 'Заявки на пробные тренировки идут потоком. Менеджер отвечает быстро, все правки вносятся сразу.',
  },
  {
    name: 'Есения Волкова',
    company: 'Магазин косметики «Люкс»',
    rating: 5,
    text: 'Продажи выросли, подписчики активные. Таргет попадает точно в целевую аудиторию.',
  },
  {
    name: 'Мирон Гусев',
    company: 'Ремонт техники «Мастер+»',
    rating: 5,
    text: 'Заявки на ремонт идут стабильно. Работают ответственно, всегда на связи, рекомендую.',
  },
  {
    name: 'Афина Сорокина',
    company: 'Турагентство «Меридиан»',
    rating: 5,
    text: 'Сообщество ожило, заявки на туры пошли. Всё прозрачно и по делу, результатом довольна.',
  },
  {
    name: 'Прохор Данилов',
    company: 'Магазин стройматериалов «Бетон»',
    rating: 5,
    text: 'Заявки от частных клиентов и бригад. Охваты растут, реклама окупается с первой недели.',
  },
  {
    name: 'Мия Егорова',
    company: 'Салон ногтей «Лак»',
    rating: 5,
    text: 'Записи расписаны на неделю вперёд. Красивые креативы и точный таргет на нашу аудиторию.',
  },
  {
    name: 'Савва Беляев',
    company: 'Клиника «Доктор»',
    rating: 5,
    text: 'Привели пациентов на нужные услуги. Отчёты подробные, всё видно в цифрах, спасибо.',
  },
  {
    name: 'Ника Дмитриева',
    company: 'Онлайн-школа рисования «Арт»',
    rating: 5,
    text: 'Настроили воронку от подписки до курса. Поток заявок вырос, стоимость лида снизилась.',
  },
  {
    name: 'Аскольд Смирнов',
    company: 'Автомойка «Сияние»',
    rating: 5,
    text: 'Клиентов прибавилось, особенно в выходные. Локальная реклама сработала отлично.',
  },
  {
    name: 'Рада Ковальчук',
    company: 'Магазин украшений «Изумруд»',
    rating: 5,
    text: 'Продажи выросли, подписчики стали активнее. Очень довольна подходом команды.',
  },
  {
    name: 'Евсей Лобанов',
    company: 'Сервис клининга «Чистота»',
    rating: 5,
    text: 'Заявки на уборку идут стабильно. Всё по договору, менеджер всегда на связи.',
  },
  {
    name: 'Лея Маркова',
    company: 'Студия маникюра «Ноготь»',
    rating: 5,
    text: 'Запись заполнена, пришлось нанимать мастера. Таргет попал точно в целевую аудиторию.',
  },
  {
    name: 'Серафим Абрамов',
    company: 'Ювелирная мастерская «Гранат»',
    rating: 5,
    text: 'Привели клиентов на дорогие заказы. Работают профессионально и с душой, рекомендую.',
  },
  {
    name: 'Ассоль Филиппова',
    company: 'Школа танцев «Движение»',
    rating: 5,
    text: 'Наборы на группы закрываются быстро. Сообщество живое, заявки идут каждый день.',
  },
  {
    name: 'Елисей Богданов',
    company: 'Магазин инструментов «Мастер»',
    rating: 5,
    text: 'Заявки от мастеров и бригад. Аналитика понятная, реклама окупается, всё отлично.',
  },
  {
    name: 'Ясмина Галеева',
    company: 'Центр развития «Лучик»',
    rating: 5,
    text: 'Привели родителей на занятия. Группы заполнены, работаем без простоев, спасибо.',
  },
  {
    name: 'Аким Денисов',
    company: 'Сервис доставки еды «Вкусно»',
    rating: 5,
    text: 'Заказы выросли в полтора раза. Таргет на нужные районы сработал идеально.',
  },
  {
    name: 'Лия Соболева',
    company: 'Фотостудия «Момент»',
    rating: 5,
    text: 'Записи на съёмки идут стабильно. Подписчики растут, всё прозрачно и по делу.',
  },
  {
    name: 'Герасим Виноградов',
    company: 'Магазин автотоваров «Руль»',
    rating: 5,
    text: 'Продажи выросли, заявки от автовладельцев. Реклама окупается, всем доволен.',
  },
  {
    name: 'Ульяна Фролова',
    company: 'Салон «Бьюти»',
    rating: 5,
    text: 'Записи на процедуры расписаны на две недели. Отличный таргет и красивые креативы.',
  },
  {
    name: 'Самсон Титов',
    company: 'Столярная мастерская «Древо»',
    rating: 5,
    text: 'Привели заказчиков на мебель ручной работы. Работают аккуратно и ответственно.',
  },
  {
    name: 'Аврора Логинова',
    company: 'Магазин книг «Читай»',
    rating: 5,
    text: 'Продажи выросли, подписчики вовлечены. Приятно работать с командой, всё по делу.',
  },
  {
    name: 'Платон Евдокимов',
    company: 'Ремонт компьютеров «Фикс»',
    rating: 5,
    text: 'Заявки на ремонт идут стабильно. Менеджер на связи каждый день, рекомендую.',
  },
  {
    name: 'Мальвина Романова',
    company: 'Онлайн-школа «Умница»',
    rating: 5,
    text: 'Привели учеников на курсы. Воронка работает, стоимость лида приятная, всё отлично.',
  },
  {
    name: 'Аскольд Никифоров',
    company: 'Магазин спорттоваров «Чемпион»',
    rating: 5,
    text: 'Заявки на товары для спорта идут потоком. Реклама окупается с первых недель.',
  },
  {
    name: 'Лада Смирнова',
    company: 'Студия красоты «Образ»',
    rating: 5,
    text: 'Записи на услуги расписаны на неделю. Команда вежливая, всё объясняют просто.',
  },
  {
    name: 'Игнатий Фомин',
    company: 'Агентство недвижимости «Дом»',
    rating: 5,
    text: 'Привели клиентов на покупку квартир. Лиды качественные, работаем на постоянной основе.',
  },
  {
    name: 'Сабина Алиева',
    company: 'Кафе «Уют»',
    rating: 5,
    text: 'Гостей стало заметно больше. Локальная реклама и живое сообщество сделали своё дело.',
  },
  {
    name: 'Ерофей Маслов',
    company: 'Магазин «Хозмаркет»',
    rating: 5,
    text: 'Продажи выросли, таргет работает. Всё по договору и с понятной отчётностью.',
  },
  {
    name: 'Дарина Григорьева',
    company: 'Студия пилатеса «Баланс»',
    rating: 5,
    text: 'Абонементы раскупаются, группы полные. Очень довольна работой команды.',
  },
  {
    name: 'Захар Петров',
    company: 'Интернет-магазин «Быт»',
    rating: 5,
    text: 'Заявки на технику для дома идут стабильно. Стоимость лида приятно радует, рекомендую.',
  },
  {
    name: 'Нелли Макарова',
    company: 'Салон «Красотка»',
    rating: 5,
    text: 'Записи заполнены, пришлось расширять команду. Таргет попал точно в аудиторию.',
  },
  {
    name: 'Гордей Ершов',
    company: 'Автосервис «Колёса»',
    rating: 5,
    text: 'Записей на ремонт стало больше. Работают ответственно, отчёты понятные.',
  },
  {
    name: 'Риана Соловьёва',
    company: 'Онлайн-школа музыки «Нота»',
    rating: 5,
    text: 'Привели учеников на уроки. Воронка работает, заявки идут каждый день, спасибо.',
  },
  {
    name: 'Лавр Андреев',
    company: 'Магазин запчастей «Деталь»',
    rating: 5,
    text: 'Заявки от автовладельцев и сервисов. Реклама окупается, всё стабильно и по договору.',
  },
  {
    name: 'Элина Гаврилова',
    company: 'Детская студия «Фантазия»',
    rating: 5,
    text: 'Группы на занятия заполнены. Родители приходят по рекламе, всё отлично работает.',
  },
  {
    name: 'Никон Шестаков',
    company: 'Сервис аренды «Прокат»',
    rating: 5,
    text: 'Заявки на аренду идут стабильно. Команда на связи, все правки вносятся быстро.',
  },
  {
    name: 'Адель Мухина',
    company: 'Бутик «Люкс»',
    rating: 5,
    text: 'Продажи выросли, подписчики активные. Красивые креативы и точный таргет, спасибо.',
  },
  {
    name: 'Ратмир Козлов',
    company: 'Клиника «Вита»',
    rating: 5,
    text: 'Пациенты записываются, сообщество живое. Отличная аналитика и понятные отчёты.',
  },
  {
    name: 'Марта Аксёнова',
    company: 'Кофейня «Бодрость»',
    rating: 5,
    text: 'Гостей стало заметно больше, особенно по утрам. Локальная реклама сработала идеально.',
  },
  {
    name: 'Силантий Богданов',
    company: 'Магазин «Сантехника»',
    rating: 5,
    text: 'Заявки от мастеров и частных клиентов. Реклама окупается, всем доволен.',
  },
  {
    name: 'Варвара Титова',
    company: 'Салон «Престиж»',
    rating: 5,
    text: 'Записи расписаны на неделю вперёд. Команда вежливая и внимательная, рекомендую.',
  },
  {
    name: 'Остап Власов',
    company: 'Фитнес «Куб»',
    rating: 5,
    text: 'Заявки на абонементы идут потоком. Менеджер отвечает быстро, всё по договору.',
  },
  {
    name: 'Прасковья Морозова',
    company: 'Магазин «Одежда»',
    rating: 5,
    text: 'Продажи через сообщество выросли. Подписчики вовлечены, таргет точный, спасибо.',
  },
  {
    name: 'Кузьма Федотов',
    company: 'Ремонт квартир «Комфорт»',
    rating: 5,
    text: 'Заявки на ремонт идут стабильно. Работают ответственно, всегда на связи.',
  },
  {
    name: 'Эвелина Розанова',
    company: 'Онлайн-курсы «Успех»',
    rating: 5,
    text: 'Поток учеников вырос, стоимость лида снизилась. Всё прозрачно и по делу.',
  },
  {
    name: 'Ермолай Севастьянов',
    company: 'Магазин «Парфюм»',
    rating: 5,
    text: 'Продажи выросли, заявки от клиентов идут. Реклама окупается, всем доволен.',
  },
  {
    name: 'Лолита Журавлёва',
    company: 'Салон «Волна»',
    rating: 5,
    text: 'Записи на услуги заполнены. Команда приятная, всё объясняют простыми словами.',
  },
  {
    name: 'Прокофий Ларионов',
    company: 'Сервис «Груз»',
    rating: 5,
    text: 'Заявки на перевозки идут стабильно. Работают чётко, отчёты понятные, рекомендую.',
  },
  {
    name: 'Агния Семёнова',
    company: 'Детский сад «Солнышко»',
    rating: 5,
    text: 'Привели родителей на запись. Группы заполнены, работаем без простоев, спасибо.',
  },
  {
    name: 'Тихомир Крылов',
    company: 'Магазин «Продукты»',
    rating: 5,
    text: 'Локальная реклама привела много покупателей. Продажи выросли, всем доволен.',
  },
  {
    name: 'Владлена Осипова',
    company: 'Студия «Маникюр»',
    rating: 5,
    text: 'Запись заполнена на две недели. Таргет попал точно в аудиторию, всё отлично.',
  },
  {
    name: 'Ирина Соколова',
    company: 'Кофейня «Арабика»',
    rating: 4,
    text: 'Результат хороший, подписчики растут. Хотелось бы чуть больше скорости в правках.',
  },
  {
    name: 'Егор Матвеев',
    company: 'Студия «ДизайнПро»',
    rating: 4,
    text: 'Заявки пошли, отчёты понятные. Иногда хочется больше личной инициативы в идеях.',
  },
  {
    name: 'Алла Гусева',
    company: 'Клиника «Медик»',
    rating: 4,
    text: 'Привели пациентов, всё по договору. Немного дольше ждали первый запуск.',
  },
  {
    name: 'Борис Кузьмин',
    company: 'Магазин «Хозтовары»',
    rating: 4,
    text: 'Продажи выросли, таргет работает. Хотелось бы больше внимания к контенту.',
  },
  {
    name: 'Софья Литвинова',
    company: 'Онлайн-курсы «Знание»',
    rating: 4,
    text: 'Лиды стабильные, стоимость приемлемая. Пара итераций заняли больше времени.',
  },
  {
    name: 'Павел Андреев',
    company: 'Автомойка «Блеск»',
    rating: 4,
    text: 'Клиентов прибавилось, всем доволен. Мелкие правки вносили не всегда сразу.',
  },
  {
    name: 'Динара Сафина',
    company: 'Салон «Красота»',
    rating: 4,
    text: 'Подписчики и записи растут. Немного не хватило глубины в стратегии.',
  },
  {
    name: 'Лев Трофимов',
    company: 'Фитнес «Power»',
    rating: 4,
    text: 'Заявки на абонементы идут. Отчётность хорошая, но хотелось бы чуть больше созвонов.',
  },
  {
    name: 'Галина Егорова',
    company: 'Бутик «Элегант»',
    rating: 4,
    text: 'Работа качественная, результат есть. Пара моментов потребовали дополнительных уточнений.',
  },
  {
    name: 'Михаил Вершинин',
    company: 'Онлайн-школа дизайна «Пиксель»',
    rating: 4,
    text: 'Заявки пошли, отчёты понятные. Немного дольше ждали запуск рекламы, но результат хороший.',
  },
  {
    name: 'Ольга Разумова',
    company: 'Салон «Персона»',
    rating: 4,
    text: 'Подписчики и записи растут. Хотелось бы чуть больше идей для контента, но в целом довольна.',
  },
  {
    name: 'Виктор Астахов',
    company: 'Автосервис «Пит-стоп»',
    rating: 4,
    text: 'Клиентов прибавилось, таргет работает. Пара правок заняли больше времени, чем ожидал.',
  },
  {
    name: 'Надежда Зимина',
    company: 'Магазин «Хлеб»',
    rating: 4,
    text: 'Продажи выросли, реклама окупается. Иногда хочется больше созвонов и личного участия.',
  },
  {
    name: 'Антон Гущин',
    company: 'Клиника «Дента»',
    rating: 4,
    text: 'Пациенты приходят, всё по договору. Отчётность хорошая, но хотелось бы больше скорости.',
  },
  {
    name: 'Кристина Ларина',
    company: 'Онлайн-курсы «Старт»',
    rating: 4,
    text: 'Лиды стабильные, стоимость приемлемая. Немного не хватило глубины в стратегии.',
  },
  {
    name: 'Денис Харитонов',
    company: 'Магазин «Спорт»',
    rating: 4,
    text: 'Заявки идут, результат есть. Пара моментов потребовали дополнительных уточнений.',
  },
  {
    name: 'Алина Богданова',
    company: 'Студия «Йога»',
    rating: 4,
    text: 'Абонементы покупают, подписчики растут. Хотелось бы чуть больше внимания к контенту.',
  },
  {
    name: 'Егор Кудрявцев',
    company: 'Сервис «Доставка+»',
    rating: 4,
    text: 'Заказы выросли, работа качественная. Мелкие правки вносили не всегда сразу.',
  },
  {
    name: 'Марина Шульгина',
    company: 'Бутик «Элегия»',
    rating: 4,
    text: 'Продажи выросли, всем довольна. Немного не хватило личной инициативы в идеях.',
  },
  {
    name: 'Сергей Лукьянов',
    company: 'Ремонт «Отделка»',
    rating: 4,
    text: 'Заявки идут стабильно, работаем дальше. Первый запуск ждали чуть дольше.',
  },
  {
    name: 'Татьяна Елисеева',
    company: 'Магазин «Одежда+»',
    rating: 4,
    text: 'Результат хороший, подписчики растут. Хотелось бы чуть больше скорости в правках.',
  },
  {
    name: 'Павел Носов',
    company: 'Клиника «Стома»',
    rating: 4,
    text: 'Пациенты записываются, всё по договору. Пара итераций заняли больше времени.',
  },
  {
    name: 'Елена Виноградова',
    company: 'Онлайн-школа «Речь»',
    rating: 4,
    text: 'Лиды качественные, стоимость приятная. Немного не хватило глубины в стратегии.',
  },
  {
    name: 'Андрей Щукин',
    company: 'Магазин «Техника+»',
    rating: 4,
    text: 'Заявки идут, результат есть. Хотелось бы больше внимания к контенту.',
  },
  {
    name: 'Светлана Романова',
    company: 'Салон «Лилия»',
    rating: 4,
    text: 'Записи растут, работа качественная. Мелкие правки вносили не всегда сразу.',
  },
  {
    name: 'Максим Ефимов',
    company: 'Фитнес «Спорт+»',
    rating: 4,
    text: 'Абонементы покупают, подписчики растут. Хотелось бы чуть больше созвонов.',
  },
  {
    name: 'Юлия Фомина',
    company: 'Магазин «Посуда»',
    rating: 4,
    text: 'Продажи выросли, всем довольна. Немного не хватило личной инициативы в идеях.',
  },
  {
    name: 'Вадим Соколов',
    company: 'Интернет-магазин «Гаджеты»',
    rating: 3,
    text: 'Подписчики пришли, но часть оказалась нецелевой. После корректировок стало лучше, но ожидал большего.',
  },
  {
    name: 'Алиса Ким',
    company: 'Студия «Творчество»',
    rating: 3,
    text: 'Результат средний: заявки есть, но не так много, как хотелось. Работали вежливо, но хочется больше результата.',
  },
  {
    name: 'Марк Лебедев',
    company: 'Сервис «Ремонт+»',
    rating: 3,
    text: 'Рост был, но медленнее ожидаемого. Договорились скорректировать стратегию, посмотрим на итог.',
  },
  {
    name: 'Вадим Галкин',
    company: 'Магазин «Сантехника+»',
    rating: 3,
    text: 'Подписчики пришли, но часть оказалась нецелевой. После корректировок стало лучше, но ожидал большего.',
  },
  {
    name: 'Алиса Прохорова',
    company: 'Студия «Живопись»',
    rating: 3,
    text: 'Результат средний: заявки есть, но не так много, как хотелось. Работали вежливо, но хочется больше результата.',
  },
  {
    name: 'Марк Осипов',
    company: 'Сервис «Ремонт»',
    rating: 3,
    text: 'Рост был, но медленнее ожидаемого. Договорились скорректировать стратегию, посмотрим на итог.',
  },
  {
    name: 'Елизавета Головина',
    company: 'Магазин «Парфюм+»',
    rating: 3,
    text: 'Часть аудитории оказалась нецелевой. После донастройки таргета ситуация улучшилась, но хотелось бы быстрее.',
  },
  {
    name: 'Кирилл Ильин',
    company: 'Клиника «Терапия»',
    rating: 3,
    text: 'Заявки были, но конверсия ниже ожидаемой. Работали корректно, но результат пока средний.',
  },
  {
    name: 'Полина Ермакова',
    company: 'Онлайн-школа «Буква»',
    rating: 3,
    text: 'Рост подписчиков был, но медленный. Надеялись на больше заявок, хотя общение приятное.',
  },
  {
    name: 'Артём Сафонов',
    company: 'Кофейня «Территория»',
    rating: 5,
    text: 'За три месяца паблик ожил: комментарии, репосты, заявки. Команда держит всё под контролем.',
  },
  {
    name: 'Вероника Коваль',
    company: 'Салон «Атлас»',
    rating: 5,
    text: 'Записи на услуги расписаны на неделю вперёд. Таргет попал точно в нашу аудиторию.',
  },
  {
    name: 'Никита Гребнев',
    company: 'Автосервис «Трасса»',
    rating: 5,
    text: 'Заявки на ремонт идут стабильно, менеджер на связи каждый день. Всем доволен.',
  },
  {
    name: 'Алиса Волкова',
    company: 'Онлайн-школа рисования «Палитра»',
    rating: 5,
    text: 'Выстроили воронку от подписки до курса. Стоимость лида снизилась, поток учеников вырос.',
  },
  {
    name: 'Данила Комаров',
    company: 'Магазин «Вело»',
    rating: 5,
    text: 'Продажи велосипедов и запчастей выросли в полтора раза. Реклама окупается, рекомендую.',
  },
  {
    name: 'Ксения Лаврова',
    company: 'Стоматология «Кристалл»',
    rating: 5,
    text: 'Пациенты записываются, сообщество живое. Отчётность подробная и понятная.',
  },
  {
    name: 'Егор Шаповалов',
    company: 'Фитнес «Максимум»',
    rating: 5,
    text: 'Заявки на абонементы идут потоком. Команда разбирается в теме и отвечает быстро.',
  },
  {
    name: 'Милана Рожкова',
    company: 'Бутик «Грация»',
    rating: 5,
    text: 'Продажи через сообщество выросли, подписчики вовлечены. Красивые креативы, точный таргет.',
  },
  {
    name: 'Сергей Баженов',
    company: 'Ремонт квартир «Ключ»',
    rating: 5,
    text: 'Заявки на ремонт идут стабильно. Работают по договору, всё прозрачно.',
  },
  {
    name: 'Диана Марченко',
    company: 'Магазин косметики «Бьюти»',
    rating: 5,
    text: 'Продажи выросли, подписчики активные. Очень довольна подходом команды.',
  },
  {
    name: 'Илья Суворов',
    company: 'Сервис доставки «Курьер»',
    rating: 5,
    text: 'Заказы выросли, таргет на нужные районы сработал идеально. Всё по договору.',
  },
  {
    name: 'Алиса Некрасова',
    company: 'Центр «Вундеркинд»',
    rating: 5,
    text: 'Привели родителей на занятия. Группы заполнены, работаем без простоев.',
  },
  {
    name: 'Максим Лобачёв',
    company: 'Магазин «Электро»',
    rating: 5,
    text: 'Заявки на технику идут каждый день. Стоимость лида ниже, чем у конкурентов.',
  },
  {
    name: 'Ева Долгова',
    company: 'Студия йоги «Поток»',
    rating: 5,
    text: 'Абонементы раскупаются, пришлось открывать новые группы. Очень довольна результатом.',
  },
  {
    name: 'Арсений Ткачёв',
    company: 'Ресторан «Бриз»',
    rating: 5,
    text: 'Бронирования на ужины и банкеты выросли. Красиво упаковали страницу и рекламу.',
  },
  {
    name: 'Полина Щербакова',
    company: 'Онлайн-курсы «Прорыв»',
    rating: 5,
    text: 'Привели целевых учеников, стоимость лида приятная. Работаем стабильно несколько месяцев.',
  },
  {
    name: 'Глеб Одинцов',
    company: 'Грузоперевозки «Магистраль»',
    rating: 5,
    text: 'Заявки от компаний приходят регулярно. Чёткий процесс и понятные отчёты.',
  },
  {
    name: 'Устинья Белова',
    company: 'Зоомагазин «Мурчик»',
    rating: 5,
    text: 'Таргет на владельцев животных сработал. Продажи выросли, отзывы отличные.',
  },
  {
    name: 'Тихон Захаров',
    company: 'Автошкола «Вираж»',
    rating: 5,
    text: 'Поток учеников вырос, группы набираются быстрее. Менеджер всегда на связи.',
  },
  {
    name: 'Альбина Гончарова',
    company: 'Магазин цветов «Тюльпан»',
    rating: 5,
    text: 'Перед праздниками заказы побили рекорды. Таргет попал точно в нашу аудиторию.',
  },
  {
    name: 'Родион Селиванов',
    company: 'Клиника «Авиценна»',
    rating: 5,
    text: 'Привели пациентов на нужные услуги. Отчёты подробные, всё видно в цифрах.',
  },
  {
    name: 'Александра Мельник',
    company: 'Салон «Нежность»',
    rating: 5,
    text: 'Записи расписаны на две недели. Отличный таргет и красивые креативы.',
  },
  {
    name: 'Семён Карпов',
    company: 'Магазин «Инструмент»',
    rating: 5,
    text: 'Заявки от мастеров и бригад. Аналитика понятная, реклама окупается.',
  },
  {
    name: 'Виолетта Руднева',
    company: 'Онлайн-школа музыки «Соло»',
    rating: 5,
    text: 'Привели учеников на уроки. Воронка работает, заявки идут каждый день.',
  },
  {
    name: 'Филипп Голубев',
    company: 'Автомойка «Автопилот»',
    rating: 5,
    text: 'Клиентов прибавилось, особенно в выходные. Локальная реклама сработала отлично.',
  },
  {
    name: 'Мирослава Жданова',
    company: 'Магазин украшений «Аметист»',
    rating: 5,
    text: 'Продажи выросли, подписчики стали активнее. Очень довольна подходом команды.',
  },
  {
    name: 'Евгений Быстров',
    company: 'Сервис клининга «Блеск»',
    rating: 5,
    text: 'Заявки на уборку идут стабильно. Всё по договору, менеджер всегда на связи.',
  },
  {
    name: 'Аделина Игнатова',
    company: 'Студия маникюра «Бархат»',
    rating: 5,
    text: 'Запись заполнена, пришлось нанимать мастера. Таргет попал точно в аудиторию.',
  },
  {
    name: 'Матвей Дорохов',
    company: 'Ювелирная мастерская «Топаз»',
    rating: 5,
    text: 'Привели клиентов на дорогие заказы. Работают профессионально и с душой.',
  },
  {
    name: 'Влада Соловей',
    company: 'Школа танцев «Ритм»',
    rating: 5,
    text: 'Наборы на группы закрываются быстро. Сообщество живое, заявки идут каждый день.',
  },
  {
    name: 'Никифор Агапов',
    company: 'Магазин «Стройка»',
    rating: 5,
    text: 'Заявки от частных клиентов и бригад. Охваты растут, реклама окупается.',
  },
  {
    name: 'София Виноградова',
    company: 'Центр развития «Росток»',
    rating: 5,
    text: 'Привели родителей на занятия. Группы заполнены, работаем без простоев.',
  },
  {
    name: 'Аркадий Митрофанов',
    company: 'Сервис доставки еды «Сытно»',
    rating: 5,
    text: 'Заказы выросли в полтора раза. Таргет на нужные районы сработал идеально.',
  },
  {
    name: 'Лина Косова',
    company: 'Фотостудия «Кадр+»',
    rating: 5,
    text: 'Записи на съёмки идут стабильно. Подписчики растут, всё прозрачно и по делу.',
  },
  {
    name: 'Роман Щербаков',
    company: 'Магазин автотоваров «Шина»',
    rating: 5,
    text: 'Продажи выросли, заявки от автовладельцев. Реклама окупается, всем доволен.',
  },
  {
    name: 'Ангелина Цветкова',
    company: 'Салон «Совершенство»',
    rating: 5,
    text: 'Записи на процедуры расписаны на две недели. Отличный таргет и креативы.',
  },
  {
    name: 'Давид Мартынов',
    company: 'Столярная мастерская «Орех»',
    rating: 5,
    text: 'Привели заказчиков на мебель ручной работы. Работают аккуратно и ответственно.',
  },
  {
    name: 'Марианна Логинова',
    company: 'Магазин книг «Фолиант»',
    rating: 5,
    text: 'Продажи выросли, подписчики вовлечены. Приятно работать с командой.',
  },
  {
    name: 'Всеволод Аникеев',
    company: 'Ремонт компьютеров «Хелп»',
    rating: 5,
    text: 'Заявки на ремонт идут стабильно. Менеджер на связи каждый день, рекомендую.',
  },
  {
    name: 'Лилия Белякова',
    company: 'Онлайн-школа «Эрудит»',
    rating: 5,
    text: 'Привели учеников на курсы. Воронка работает, стоимость лида приятная.',
  },
  {
    name: 'Гавриил Орлов',
    company: 'Магазин спорттоваров «Атлет»',
    rating: 5,
    text: 'Заявки на товары для спорта идут потоком. Реклама окупается с первых недель.',
  },
  {
    name: 'Роза Федосеева',
    company: 'Студия красоты «Имидж»',
    rating: 5,
    text: 'Записи на услуги расписаны на неделю. Команда вежливая, всё объясняют просто.',
  },
  {
    name: 'Спартак Киселёв',
    company: 'Агентство недвижимости «Этажи»',
    rating: 5,
    text: 'Привели клиентов на покупку квартир. Лиды качественные, работаем постоянно.',
  },
  {
    name: 'Тамара Алиева',
    company: 'Кафе «Лакомка»',
    rating: 5,
    text: 'Гостей стало заметно больше. Локальная реклама и живое сообщество сделали своё дело.',
  },
  {
    name: 'Фома Максимов',
    company: 'Магазин «Склад»',
    rating: 5,
    text: 'Продажи выросли, таргет работает. Всё по договору и с понятной отчётностью.',
  },
  {
    name: 'Алисия Григорьева',
    company: 'Студия пилатеса «Форма»',
    rating: 5,
    text: 'Абонементы раскупаются, группы полные. Очень довольна работой команды.',
  },
  {
    name: 'Зиновий Панкратов',
    company: 'Интернет-магазин «Комфорт»',
    rating: 5,
    text: 'Заявки на товары для дома идут стабильно. Стоимость лида приятно радует.',
  },
  {
    name: 'Неонила Макарова',
    company: 'Салон «Красотка+»',
    rating: 5,
    text: 'Записи заполнены, пришлось расширять команду. Таргет попал точно в аудиторию.',
  },
  {
    name: 'Галактион Ершов',
    company: 'Автосервис «Колёса+»',
    rating: 5,
    text: 'Записей на ремонт стало больше. Работают ответственно, отчёты понятные.',
  },
  {
    name: 'Рада Соловьёва',
    company: 'Онлайн-школа музыки «Аккорд»',
    rating: 5,
    text: 'Привели учеников на уроки. Воронка работает, заявки идут каждый день.',
  },
  {
    name: 'Лаврентий Андреев',
    company: 'Магазин запчастей «Автодеталь»',
    rating: 5,
    text: 'Заявки от автовладельцев и сервисов. Реклама окупается, всё стабильно.',
  },
  {
    name: 'Эмма Гаврилова',
    company: 'Детская студия «Сказка»',
    rating: 5,
    text: 'Группы на занятия заполнены. Родители приходят по рекламе, всё отлично.',
  },
  {
    name: 'Никанор Шестаков',
    company: 'Сервис аренды «Рент»',
    rating: 5,
    text: 'Заявки на аренду идут стабильно. Команда на связи, правки вносятся быстро.',
  },
  {
    name: 'Адель Мухина',
    company: 'Бутик «Люкс+»',
    rating: 5,
    text: 'Продажи выросли, подписчики активные. Красивые креативы и точный таргет.',
  },
  {
    name: 'Ратмир Козлов',
    company: 'Клиника «Вита+»',
    rating: 5,
    text: 'Пациенты записываются, сообщество живое. Отличная аналитика и отчёты.',
  },
  {
    name: 'Марта Аксёнова',
    company: 'Кофейня «Пробуждение»',
    rating: 5,
    text: 'Гостей стало заметно больше, особенно по утрам. Локальная реклама сработала.',
  },
  {
    name: 'Сильвестр Богданов',
    company: 'Магазин «Водопровод»',
    rating: 5,
    text: 'Заявки от мастеров и частных клиентов. Реклама окупается, всем доволен.',
  },
  {
    name: 'Василиса Титова',
    company: 'Салон «Престиж+»',
    rating: 5,
    text: 'Записи расписаны на неделю вперёд. Команда вежливая и внимательная.',
  },
  {
    name: 'Остап Власов',
    company: 'Фитнес «Куб+»',
    rating: 5,
    text: 'Заявки на абонементы идут потоком. Менеджер отвечает быстро, всё по договору.',
  },
  {
    name: 'Прасковья Морозова',
    company: 'Магазин «Гардероб»',
    rating: 5,
    text: 'Продажи через сообщество выросли. Подписчики вовлечены, таргет точный.',
  },
  {
    name: 'Кузьма Федотов',
    company: 'Ремонт квартир «Уют+»',
    rating: 5,
    text: 'Заявки на ремонт идут стабильно. Работают ответственно, всегда на связи.',
  },
  {
    name: 'Эвелина Розанова',
    company: 'Онлайн-курсы «Фортуна»',
    rating: 5,
    text: 'Поток учеников вырос, стоимость лида снизилась. Всё прозрачно и по делу.',
  },
  {
    name: 'Ермолай Севастьянов',
    company: 'Магазин «Аромат»',
    rating: 5,
    text: 'Продажи выросли, заявки от клиентов идут. Реклама окупается, всем доволен.',
  },
  {
    name: 'Лолита Журавлёва',
    company: 'Салон «Волна+»',
    rating: 5,
    text: 'Записи на услуги заполнены. Команда приятная, всё объясняют простыми словами.',
  },
  {
    name: 'Прокофий Ларионов',
    company: 'Сервис «Груз+»',
    rating: 5,
    text: 'Заявки на перевозки идут стабильно. Работают чётко, отчёты понятные.',
  },
  {
    name: 'Агния Семёнова',
    company: 'Детский сад «Солнышко+»',
    rating: 5,
    text: 'Привели родителей на запись. Группы заполнены, работаем без простоев.',
  },
  {
    name: 'Тихомир Крылов',
    company: 'Магазин «Ферма»',
    rating: 5,
    text: 'Локальная реклама привела много покупателей. Продажи выросли, всем доволен.',
  },
  {
    name: 'Владлена Осипова',
    company: 'Студия «Ноготки»',
    rating: 5,
    text: 'Запись заполнена на две недели. Таргет попал точно в аудиторию, всё отлично.',
  },
  {
    name: 'Анфиса Лебедева',
    company: 'Кофейня «Зерно+»',
    rating: 5,
    text: 'За три месяца паблик ожил: комментарии, заявки. Команда держит всё под контролем.',
  },
  {
    name: 'Герман Царёв',
    company: 'Салон «Формат»',
    rating: 5,
    text: 'Записи на услуги расписаны на неделю вперёд. Таргет попал точно в аудиторию.',
  },
  {
    name: 'Милена Тарасова',
    company: 'Онлайн-школа «Каллиграфия»',
    rating: 5,
    text: 'Выстроили воронку от подписки до курса. Поток учеников вырос, лид дешевле.',
  },
  {
    name: 'Витольд Гуляев',
    company: 'Магазин «Аксессуары»',
    rating: 5,
    text: 'Продажи выросли в полтора раза. Реклама окупается, рекомендую команду.',
  },
  {
    name: 'Оксана Снегирёва',
    company: 'Стоматология «Эстетика»',
    rating: 5,
    text: 'Пациенты записываются, сообщество живое. Отчётность подробная и понятная.',
  },
  {
    name: 'Ян Коваленко',
    company: 'Фитнес «Импульс»',
    rating: 5,
    text: 'Заявки на абонементы идут потоком. Команда разбирается и отвечает быстро.',
  },
  {
    name: 'Белла Рыбакова',
    company: 'Бутик «Изюминка»',
    rating: 5,
    text: 'Продажи через сообщество выросли, подписчики вовлечены. Точный таргет.',
  },
  {
    name: 'Пётр Сазонов',
    company: 'Ремонт квартир «Новострой»',
    rating: 5,
    text: 'Заявки на ремонт идут стабильно. Работают по договору, всё прозрачно.',
  },
  {
    name: 'Альберт Ким',
    company: 'Ресторан «Гавань»',
    rating: 4,
    text: 'Бронирований стало больше, но хотелось бы чуть больше скорости в правках.',
  },
  {
    name: 'Есения Овчинникова',
    company: 'Онлайн-курсы «Лидер»',
    rating: 4,
    text: 'Лиды стабильные, стоимость приемлемая. Немного не хватило глубины в стратегии.',
  },
  {
    name: 'Герман Коваленко',
    company: 'Грузоперевозки «Тракт»',
    rating: 4,
    text: 'Заявки от компаний приходят. Пара правок заняли больше времени, чем ожидал.',
  },
  {
    name: 'Амелия Сорокина',
    company: 'Зоомагазин «Пёсик»',
    rating: 4,
    text: 'Продажи выросли, таргет работает. Хотелось бы больше внимания к контенту.',
  },
  {
    name: 'Витольд Абрамов',
    company: 'Автошкола «Драйв+»',
    rating: 4,
    text: 'Поток учеников вырос, всё по договору. Иногда хочется больше личной инициативы.',
  },
  {
    name: 'Радмила Ефимова',
    company: 'Магазин цветов «Роза»',
    rating: 4,
    text: 'Перед праздниками заказы выросли. Немного дольше ждали первый запуск.',
  },
  {
    name: 'Григорий Анисимов',
    company: 'Клиника «Гиппократ»',
    rating: 4,
    text: 'Пациенты приходят, отчёты понятные. Хотелось бы чуть больше созвонов.',
  },
  {
    name: 'Нинель Рожкова',
    company: 'Салон «Виола»',
    rating: 4,
    text: 'Записи растут, работа качественная. Мелкие правки вносили не всегда сразу.',
  },
  {
    name: 'Фаддей Комаров',
    company: 'Магазин «Хозблок»',
    rating: 4,
    text: 'Продажи выросли, всем доволен. Немного не хватило личной инициативы в идеях.',
  },
  {
    name: 'Вирсавия Фомина',
    company: 'Онлайн-школа «Голос»',
    rating: 4,
    text: 'Лиды качественные, стоимость приятная. Пара итераций заняли больше времени.',
  },
  {
    name: 'Соломон Дементьев',
    company: 'Магазин «Автоаксессуары»',
    rating: 4,
    text: 'Заявки идут, результат есть. Хотелось бы больше внимания к контенту.',
  },
  {
    name: 'Рената Щукина',
    company: 'Салон «Элегия+»',
    rating: 4,
    text: 'Продажи выросли, всем довольна. Немного не хватило глубины в стратегии.',
  },
  {
    name: 'Гордей Степанов',
    company: 'Ремонт «Отделка+»',
    rating: 4,
    text: 'Заявки идут стабильно. Первый запуск ждали чуть дольше, но результат хороший.',
  },
  {
    name: 'Мирослава Тихомирова',
    company: 'Магазин «Стиль+»',
    rating: 4,
    text: 'Результат хороший, подписчики растут. Хотелось бы чуть больше скорости в правках.',
  },
  {
    name: 'Ефрем Носов',
    company: 'Клиника «Дент+»',
    rating: 4,
    text: 'Пациенты записываются, всё по договору. Пара итераций заняли больше времени.',
  },
  {
    name: 'Авдотья Виноградова',
    company: 'Онлайн-школа «Слово»',
    rating: 4,
    text: 'Лиды качественные, стоимость приятная. Немного не хватило глубины в стратегии.',
  },
  {
    name: 'Аристарх Щукин',
    company: 'Магазин «Бытовая техника»',
    rating: 4,
    text: 'Заявки идут, результат есть. Хотелось бы больше внимания к контенту.',
  },
  {
    name: 'Серафима Романова',
    company: 'Салон «Магнолия»',
    rating: 4,
    text: 'Записи растут, работа качественная. Мелкие правки вносили не всегда сразу.',
  },
  {
    name: 'Маркел Ефимов',
    company: 'Фитнес «Пик»',
    rating: 3,
    text: 'Подписчики пришли, но часть оказалась нецелевой. После корректировок стало лучше, но ожидал большего.',
  },
  {
    name: 'Лариса Ким',
    company: 'Студия «Вдохновение»',
    rating: 3,
    text: 'Результат средний: заявки есть, но не так много, как хотелось. Работали вежливо, но хочется больше результата.',
  },
  {
    name: 'Вениамин Лебедев',
    company: 'Сервис «Мастер+»',
    rating: 3,
    text: 'Рост был, но медленнее ожидаемого. Договорились скорректировать стратегию, посмотрим на итог.',
  },
  {
    name: 'Руслана Галкина',
    company: 'Магазин «Сантехника+»',
    rating: 3,
    text: 'Часть аудитории оказалась нецелевой. После донастройки таргета ситуация улучшилась, но хотелось бы быстрее.',
  },
  {
    name: 'Изольда Прохорова',
    company: 'Студия «Мольберт»',
    rating: 3,
    text: 'Рост подписчиков был, но медленный. Надеялись на больше заявок, хотя общение приятное.',
  },
  {
    name: 'Казимир Осипов',
    company: 'Сервис «РемонтПро»',
    rating: 3,
    text: 'Заявки были, но конверсия ниже ожидаемой. Работали корректно, но результат пока средний.',
  },
  {
    name: 'Даниил Ковалёв',
    company: 'Кофейня «Формат»',
    rating: 5,
    text: 'За месяц паблик ожил: комментарии, репосты, заявки в директ. Команда держит всё под контролем.',
  },
  {
    name: 'Алисия Мельник',
    company: 'Салон «Лотос»',
    rating: 5,
    text: 'Записи на услуги расписаны на две недели вперёд. Таргет попал точно в нашу аудиторию.',
  },
  {
    name: 'Герман Ткачёв',
    company: 'Автосервис «Штурм»',
    rating: 5,
    text: 'Заявки на ремонт идут стабильно, менеджер на связи каждый день. Всем доволен.',
  },
  {
    name: 'Виолетта Орлова',
    company: 'Онлайн-школа «Пиксель+»',
    rating: 5,
    text: 'Выстроили воронку от подписки до курса. Стоимость лида снизилась, поток учеников вырос.',
  },
  {
    name: 'Матвей Гончаров',
    company: 'Магазин «Скутер»',
    rating: 5,
    text: 'Продажи запчастей выросли в полтора раза. Реклама окупается, рекомендую.',
  },
  {
    name: 'Есения Лаврова',
    company: 'Стоматология «Блеск»',
    rating: 5,
    text: 'Пациенты записываются, сообщество живое. Отчётность подробная и понятная.',
  },
  {
    name: 'Аркадий Шаповалов',
    company: 'Фитнес «Пульс»',
    rating: 5,
    text: 'Заявки на абонементы идут потоком. Команда разбирается в теме и отвечает быстро.',
  },
  {
    name: 'Милана Рожкова',
    company: 'Бутик «Очарование»',
    rating: 5,
    text: 'Продажи через сообщество выросли, подписчики вовлечены. Красивые креативы, точный таргет.',
  },
  {
    name: 'Сергей Баженов',
    company: 'Ремонт квартир «Стройдом»',
    rating: 5,
    text: 'Заявки на ремонт идут стабильно. Работают по договору, всё прозрачно.',
  },
  {
    name: 'Диана Марченко',
    company: 'Магазин косметики «Глянец»',
    rating: 5,
    text: 'Продажи выросли, подписчики активные. Очень довольна подходом команды.',
  },
  {
    name: 'Илья Суворов',
    company: 'Сервис доставки «Экспресс»',
    rating: 5,
    text: 'Заказы выросли, таргет на нужные районы сработал идеально. Всё по договору.',
  },
  {
    name: 'Алиса Некрасова',
    company: 'Центр «Почемучка»',
    rating: 5,
    text: 'Привели родителей на занятия. Группы заполнены, работаем без простоев.',
  },
  {
    name: 'Максим Лобачёв',
    company: 'Магазин «Вольтмарт»',
    rating: 5,
    text: 'Заявки на технику идут каждый день. Стоимость лида ниже, чем у конкурентов.',
  },
  {
    name: 'Ева Долгова',
    company: 'Студия йоги «Шанти»',
    rating: 5,
    text: 'Абонементы раскупаются, пришлось открывать новые группы. Очень довольна результатом.',
  },
  {
    name: 'Арсений Ткачёв',
    company: 'Ресторан «Парус»',
    rating: 5,
    text: 'Бронирования на ужины и банкеты выросли. Красиво упаковали страницу и рекламу.',
  },
  {
    name: 'Полина Щербакова',
    company: 'Онлайн-курсы «Апгрейд»',
    rating: 5,
    text: 'Привели целевых учеников, стоимость лида приятная. Работаем стабильно несколько месяцев.',
  },
  {
    name: 'Глеб Одинцов',
    company: 'Грузоперевозки «Автотрек»',
    rating: 5,
    text: 'Заявки от компаний приходят регулярно. Чёткий процесс и понятные отчёты.',
  },
  {
    name: 'Устинья Белова',
    company: 'Зоомагазин «Барсик»',
    rating: 5,
    text: 'Таргет на владельцев животных сработал. Продажи выросли, отзывы отличные.',
  },
  {
    name: 'Тихон Захаров',
    company: 'Автошкола «Поворот»',
    rating: 5,
    text: 'Поток учеников вырос, группы набираются быстрее. Менеджер всегда на связи.',
  },
  {
    name: 'Альбина Гончарова',
    company: 'Магазин цветов «Ирис»',
    rating: 5,
    text: 'Перед праздниками заказы побили рекорды. Таргет попал точно в нашу аудиторию.',
  },
  {
    name: 'Родион Селиванов',
    company: 'Клиника «Гален»',
    rating: 5,
    text: 'Привели пациентов на нужные услуги. Отчёты подробные, всё видно в цифрах.',
  },
  {
    name: 'Александра Мельник',
    company: 'Салон «Бархат+»',
    rating: 5,
    text: 'Записи расписаны на две недели. Отличный таргет и красивые креативы.',
  },
  {
    name: 'Семён Карпов',
    company: 'Магазин «Инструмент+»',
    rating: 5,
    text: 'Заявки от мастеров и бригад. Аналитика понятная, реклама окупается.',
  },
  {
    name: 'Виолетта Руднева',
    company: 'Онлайн-школа музыки «Крещендо»',
    rating: 5,
    text: 'Привели учеников на уроки. Воронка работает, заявки идут каждый день.',
  },
  {
    name: 'Филипп Голубев',
    company: 'Автомойка «Чистый двор»',
    rating: 5,
    text: 'Клиентов прибавилось, особенно в выходные. Локальная реклама сработала отлично.',
  },
  {
    name: 'Мирослава Жданова',
    company: 'Магазин украшений «Бирюза»',
    rating: 5,
    text: 'Продажи выросли, подписчики стали активнее. Очень довольна подходом команды.',
  },
  {
    name: 'Евгений Быстров',
    company: 'Сервис клининга «Порядок»',
    rating: 5,
    text: 'Заявки на уборку идут стабильно. Всё по договору, менеджер всегда на связи.',
  },
  {
    name: 'Аделина Игнатова',
    company: 'Студия маникюра «Глянец+»',
    rating: 5,
    text: 'Запись заполнена, пришлось нанимать мастера. Таргет попал точно в аудиторию.',
  },
  {
    name: 'Альберт Ким',
    company: 'Ресторан «Фортуна»',
    rating: 4,
    text: 'Бронирований стало больше, но хотелось бы чуть больше скорости в правках.',
  },
  {
    name: 'Есения Овчинникова',
    company: 'Онлайн-курсы «Ментор»',
    rating: 4,
    text: 'Лиды стабильные, стоимость приемлемая. Немного не хватило глубины в стратегии.',
  },
  {
    name: 'Герман Коваленко',
    company: 'Грузоперевозки «Трасса+»',
    rating: 4,
    text: 'Заявки от компаний приходят. Пара правок заняли больше времени, чем ожидал.',
  },
  {
    name: 'Амелия Сорокина',
    company: 'Зоомагазин «Мурка»',
    rating: 4,
    text: 'Продажи выросли, таргет работает. Хотелось бы больше внимания к контенту.',
  },
  {
    name: 'Витольд Абрамов',
    company: 'Автошкола «Маршрут»',
    rating: 4,
    text: 'Поток учеников вырос, всё по договору. Иногда хочется больше личной инициативы.',
  },
  {
    name: 'Радмила Ефимова',
    company: 'Магазин цветов «Пион+»',
    rating: 4,
    text: 'Перед праздниками заказы выросли. Немного дольше ждали первый запуск.',
  },
  {
    name: 'Маркел Ефимов',
    company: 'Фитнес «Рельеф»',
    rating: 3,
    text: 'Подписчики пришли, но часть оказалась нецелевой. После корректировок стало лучше, но ожидал большего.',
  },
  {
    name: 'Лариса Ким',
    company: 'Студия «Этюд»',
    rating: 3,
    text: 'Результат средний: заявки есть, но не так много, как хотелось. Работали вежливо, но хочется больше результата.',
  },
];